import React, { useEffect } from 'react';
import UserAPI from './UserAPI';
import { formatTitleToDB, formatTitleToDisplay } from '../utils/Functions';
import { useState } from 'react';
import TuneCoinImage from '../images/tunecoin.png';
import { Container, Row, Col, Form, Button, Alert, Table, Image } from 'react-bootstrap';

const UserSongsMenu = ({ sessionName }) => {
    const [songs, setSongs] = useState([]);
    const [confirmationMessage, setConfirmationMessage] = useState('');

    const loadSongs = async() => {
        try {
            const requestBody = JSON.stringify({
                'request_type': 'user',
                'idToken': localStorage.getItem('idToken'),
                'user_request_type': 'songs',
                'action': 'getSessionSongList',
                'session_name': sessionName
            });

            const jsonData = await UserAPI(requestBody);
            const result = JSON.parse(jsonData.body);
            
            // Create a new array with all songs before setting state
            const newSongs = result.map(element => ({
                title: formatTitleToDisplay(element[0]),
                artist: formatTitleToDisplay(element[1])
            }));
            
            setSongs(newSongs);
        } catch (error) {
            console.error('Error loading songs:', error);
        }
    };
    
    const handleRequest = async (index) => {
        try {
            const credits = document.getElementById('creditsInput').value;
            if (!credits || credits < 1) {
                setConfirmationMessage("Please enter a valid number of credits");
                setTimeout(() => setConfirmationMessage(''), 2000);
                return;
            }

            const title = songs[index].title;
            const artist = songs[index].artist;
            const formattedTitle = formatTitleToDB(title);
            const formattedArtist = formatTitleToDB(artist);
            
            const requestBody = JSON.stringify({
                'request_type': 'transaction',
                'idToken': localStorage.getItem('idToken'),
                'transaction_type': 'songrequest',
                'recipient': sessionName,
                'song_name': formattedTitle,
                'artist': formattedArtist,
                'credits': parseInt(credits, 10)
            });
            
            await UserAPI(requestBody);
            setConfirmationMessage("Requested!");
            setTimeout(() => setConfirmationMessage(''), 2000);
        } catch (error) {
            console.error('Error requesting song:', error);
            setConfirmationMessage("Error requesting song");
            setTimeout(() => setConfirmationMessage(''), 2000);
        }
    }

    useEffect(() => {
        if (sessionName) {
            loadSongs();
        }
    }, [sessionName]);

    return (
        <Container fluid>
            <Row className="mb-3 align-items-center">
                <Col>
                    <div className="d-flex align-items-center gap-2">
                        <span>Enter credits to request a song</span>
                        <Form.Control
                            id="creditsInput"
                            type="number"
                            min={1}
                            placeholder="Credits"
                            style={{ width: '5rem' }}
                        />
                        <Image 
                            src={TuneCoinImage} 
                            alt="TuneCoin" 
                            style={{ width: '1em', height: '1em' }} 
                        />
                    </div>
                </Col>
            </Row>

            {confirmationMessage && (
                <Row className="mb-3">
                    <Col>
                        <Alert variant="success" className="py-2">
                            {confirmationMessage}
                        </Alert>
                    </Col>
                </Row>
            )}

            <Row>
                <Col>
                    <div className="table-responsive">
                        <Table variant="dark" hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '40%', whiteSpace: 'nowrap' }}>Title</th>
                                    <th style={{ width: '40%', whiteSpace: 'nowrap' }}>Artist</th>
                                    <th style={{ width: '20%' }} className="text-end"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {songs.map((song, index) => (
                                    <tr key={index}>
                                        <td className="text-truncate" style={{ maxWidth: '200px' }}>{song.title}</td>
                                        <td className="text-truncate" style={{ maxWidth: '200px' }}>{song.artist}</td>
                                        <td className="text-end" style={{ whiteSpace: 'nowrap' }}>
                                            <Button 
                                                variant="outline-light"
                                                onClick={() => handleRequest(index)}
                                                size="sm"
                                            >
                                                Request
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default UserSongsMenu;